import { CitiesFilterFactory } from './cities.factory';
import { CompetitorsFilterFactory } from './competitors.factory';
import { CustomersFilterFactory } from './customers.factory';
import { DealershipsFilterFactory } from './dealerships.factory';
import { StorePlannedFilterFactory } from './storePlanned.factory.js';
import { StoresMotocycleFilterFactory } from './storesMotocycle.factory.js';
import { StoresConsortiumFilterFactory } from './storesConsortium.factory.js';
import { StoreInactiveFactory } from './storeinactive.factory';
import { DirectSalesFactory } from './directSales.factory';
import { ClusterSalesFactory } from './clusterSales.factory';
import { GreenfieldFilterFactory } from './greenfield.factory';
import { NewGreenfieldFilterFactory } from './newGreenfield.factory';
import { BrownfieldFilterFactory } from './brownfield.factory';
import { LayersFilterFactory } from './layers.factory';
import { RetentionFilterFactory } from './retention.factory';
import { FuelStationFactory } from './fuelStation.factory';
import { WorkshopPartFactory } from './workshopPart.factory';
import { AfterSalesShapeFactory } from './afterSalesShape.factory';
import { ClientSalesAfterSalesFactory } from './clientSalesAfterSales.factory';
import { StoreAfterSalesFactory } from './storeAfterSales.factory';
import { DealershipAfterSalesFactory } from './dealershipAfterSales.factory';
import { CustomersAfterSalesFactory } from './customersAfterSales';
import { MulticriteriaAfterSalesFactory } from './multicriteriaAfterSales.factory';
import { UnapprovedStoresFactory } from './unapprovedStores.factory';
import { DncFilterFactory } from './dnc.factory';
import { CompanyCustomersPotentialAfterSalesFactory } from './companyCustomersPotentialAfterSales.factory';
import { PgtsFactory } from './pgts.factory.js';
import { MallCentersFactory } from './mallCenters.factory';

const types = {
    cities: (props) => new CitiesFilterFactory(props),
    competitors: (props) => new CompetitorsFilterFactory(props),
    customers: (props) => new CustomersFilterFactory(props),
    dealerships: (props) => new DealershipsFilterFactory(props),
    ['stores motocycle']: (props) => new StoresMotocycleFilterFactory(props),
    ['stores consortium']: (props) => new StoresConsortiumFilterFactory(props),
    ['store inactive']: (props) => new StoreInactiveFactory(props),
    ['unapproved stores']: (props) => new UnapprovedStoresFactory(props),
    ['store planned']: (props) => new StorePlannedFilterFactory(props),
    directSales: (props) => new DirectSalesFactory(props),
    fuelStation: (props) => new FuelStationFactory(props),
    greenfield: (props) => new GreenfieldFilterFactory(props),
    newgreenfield: (props) => new NewGreenfieldFilterFactory(props),
    brownfield: (props) => new BrownfieldFilterFactory(props),
    retention: (props) => new RetentionFilterFactory(props),
    clusterSales: (props) => new ClusterSalesFactory(props),
    mallCenters: (props) => new MallCentersFactory(props),
    default: (props) => new LayersFilterFactory(props),
    workshopPart: (props) => new WorkshopPartFactory(props),
    afterSalesShape: (props) => new AfterSalesShapeFactory(props),
    clientSalesAfterSales: (props) => new ClientSalesAfterSalesFactory(props),
    dncflexible: (props) => new DncFilterFactory(props),
    ['network after sales']: (props) => new StoreAfterSalesFactory(props),
    ['competitors after sales']: (props) => new StoreAfterSalesFactory(props),
    ['store inactive after sales']: (props) => new StoreAfterSalesFactory(props),
    dealershipAfterSales: (props) => new DealershipAfterSalesFactory(props),
    ['customers after sales']: (props) => new CustomersAfterSalesFactory(props),
    multicriteriaAfterSales: (props) => new MulticriteriaAfterSalesFactory(props),
    ['company customers potential after sales']: (props) => new CompanyCustomersPotentialAfterSalesFactory(props),
    pgts: (props) => new PgtsFactory(props),
};

export const controlsFactory = (props) => {
    const constructor = types[props.type] || types.default;
    return constructor({ options: props.options, currentMap: props.currentMap });
};



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/index.js